import MyFooter           from '../../../views/layout-footer'
import Breadcrumb         from '../../../views/breadcrumb'
import IconsRender        from '../../../templates/widgets/icons-render'
import ImagesRender       from '../../../templates/widgets/images-render'
import FormGenerator      from '../../../forms/FormGenerator'
import GridGenerator      from '../../../grids/grid-generator'
import FormActionButton   from '../../../widgets/forms/form-action-button'
import ResourceGetter
                          from '../../../../model/resource/getter/resource-getter'
import FormElementTypes   from '../../../../model/FormElementTypes'
import ValueTypeConverter from '../../../../model/converter/ValueTypeConverter'
import Bootbox            from '../../../../model/Bootbox'
import Swal               from 'sweetalert2/dist/sweetalert2.js'
import DefinitionGetter
                          from '../../../../model/resource/getter/definitions-getter'
import PDELinkGenerator   from '../../../../model/wrapper/pde-link-params'
import FileLoader         from '../../../../model/loader/file-loader'
import SessionStorage     from '../../../../model/storage/session-storage'
import DataGetter         from '../../../../model/resource/getter/data-getter'
import Definition         from '../../../../model/entity/Definition'
import DatetimeParser     from '../../../../model/parser/datetime-parser'
import FormDataChangeHelper
                          from '../../../../model/helper/forms/form-data-change-helper'

export default {
  name:       'dynamic-editor-page',
  props:      {
    propDef:           {
      type:    Object,
      default: () => {
        return null
      }
    },
    defaults:          {
      type:    Object,
      default: () => {
        return null
      }
    },
    parentDef:         {
      type:    Object,
      default: () => {
        return null
      }
    },
    redir:             {
      type:    String,
      default: ''
    },
    showBreadcrumb:    {
      type:    Boolean,
      default: true
    },
    homepageRedirect:  {
      type:    Boolean,
      default: false
    },
    dashboardRedirect: {
      type:    Boolean,
      default: false
    },
    triggerCalrec:     {
      type:    Boolean,
      default: false
    }
  },
  components: {
    MyFooter,
    FormGenerator,
    GridGenerator,
    Breadcrumb,
    IconsRender,
    ImagesRender,
    FormActionButton
  },

  data () {
    return {
      id:          this.$route.params.id,
      page:        this.$route.params.page,
      idStructure: this.$route.params.idStructure,
      parent:      this.$route.params.parent,

      def:              undefined,
      resource:         undefined,
      breadcrumbItems:  [],
      innerSubForms:    [],
      innerMasterSlave: [], // @TODO: fakt nevim jak to mam pojmenovat uz !!
      innerFormMenu:    [],
      innerDefaults:    null,
      innerOriginals:   {},
      listIcons:        [],
      listImages:       [],
      buttonsDef:       [],
      gallery:          null,

      renderBaseForm:         false,
      showDownload:           false,
      subFormDefinition:      undefined,
      subFormWhereCondition:  '',
      subFormDefinitionFired: false,

      computed: {
        defaults:        null,
        sourceType:      null,
        innerIsReadOnly: null,
        h1:              null
      },

      rowData:                    undefined,
      buttons:                    [],
      newrecordActionButtonFired: false,
      submitSuccessCallbacks:     [],
      businessRuleCallStack:      [],
      setRowData:                 true,
      form:                       undefined,
      showPreloader:              true,
      dataInit:                   false,
      formDataCheckFunction:      null,
      updateDataRequest:          null,
      formDataChanged:            null,
      onlySave:                   false,
      submitTriggered:            false,
      dataChanged:                false,
      changeUrlDisabled:          false
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (this.changeUrlDisabled) {
      this.changeUrlDisabled = false
      next()
      return
    }

    this.formDataCheckFunction(() => {next()}, () => {next()})
  },

  beforeRouteLeave (to, from, next) {
    this.formDataCheckFunction(() => {next()}, () => {next()})
  },

  created () {
    if (!this.page && this.propDef) {
      this.page = this.propDef.code
    }
    if (!this.id && this.defaults && this.defaults.hasOwnProperty('ID')) {
      this.id = this.defaults.ID
    }

    window.scrollTo(0, 0)

    this._initBase()
    this._initFormDataCheckFunction()
    this._initUpdateDataRequest()
    this._initFormDataChanged()

    document.body.classList.remove('printable')
  },

  computed: {
    innerSourceType: {
      get: function () {
        if (this.computed.sourceType) {
          return this.computed.sourceType
        }

        return this.def.viewName
      },
      set: function (value) {
        this.computed.sourceType = value
      }
    },
    innerH1:         {
      get: function () {
        if (this.computed.h1) {
          return this.computed.h1
        }

        return this.def.dictionaryKeyCode
      },
      set: function (value) {
        this.computed.h1 = value
      }
    },
    innerIsReadOnly: {
      get: function () {
        if (this.computed.innerIsReadOnly) {
          return this.computed.innerIsReadOnly
        }

        return this.def.isReadOnly
      },
      set: function (value) {
        this.computed.innerIsReadOnly = value
      }
    },
    parentParsed:    {
      get: function () {
        if (!this.parent) {
          return null
        }

        return JSON.parse(this.parent)
      }
    },
    parentProp:      {
      get: function () {
        return { def: this.def, data: this.innerDefaults }
      }
    }
  },

  mounted () {
 $(document).on('keydown.dynamicEditor', 'input, select', function (e) {
    if (!e.ctrlKey && e.key === 'Enter') {
      var self = $(this),
          form = self.parents('.vue-component-holder:eq(0)'),
          focusable,
          next

      focusable = form.find(
        'input:not([disabled="disabled"]):not(.tt-hint),select:not([tabindex="-98"]),textarea,button')
                      .filter(':visible')
      next      = focusable.eq(focusable.index(this) + 1)
      if (next.length) {
        const parent = next.parent()
        if (parent.hasClass('bootstrap-select')) {
          parent.find('button').trigger('click')
        }

        next.focus().select()
      }
      else {
        form.submit()
      }
      return false
    }
  })

    /*
    $(document).on('keydown', (e) => {
      if (e.ctrlKey && e.key === 'Enter' && !this.dashboardRedirect) {
        const self   = $(this),
              // form   = self.parents('.vue-component-holder'),
              button = $(document).find('.btn-save-data')

        if (button.length) {
          button.trigger('click')
        }

        return false
      }

      if (e.key === 'Escape') {
        this._back()
      }
    })
    */

 $(document).on('keydown.dynamicEditor', (e) => {
    console.log('Key pressed:', e.key)

    if (e.ctrlKey && e.key === 'Enter' && !this.dashboardRedirect) {
      const button = $(document).find('.btn-save-data')

      if (button.length) {
        button.trigger('click')
      }

      return false
    }

    if (e.key === 'Escape') {
      console.log('ESC detected, calling _back()')
      this._back()
      return false
    }
  })

    $(document).on('click', '.panel-title', (e) => {
      const $this  = $(e.target),
            parent = $this.closest('.row'),
            showed = parent.find('.panel-collapse.show')

      if (showed.length) {
        $(showed[0]).collapse('toggle')
      }
    })

    if (this.triggerCalrec) {
      this._callBusinessRules(null)
      this.triggerCalrec = false
    }
  },

  updated () {
    setTimeout(() => {
      $(this.$refs.tabHolder).responsiveTabs()
    }, 150)

    if (this.renderBaseForm) {
      $('#tab-holder li a:not(:first)').removeClass('active')
    }

    if (this.dataInit && this.$refs.form) {
      this.dataInit = false

      Object.keys(this.innerDefaults).map(key => {
        let stValue = this.innerDefaults['ST' + key]
              ? this.innerDefaults['ST' + key]
              : this.innerDefaults[key],
            values  = {
              value:   this.innerDefaults[key],
              stValue: stValue
            }
        this.$refs.form.setValue(key, values) //values
        this.$refs.form.setValue(key, values, true) //values
      })
    }
  },

  /*
  destroyed () {
    $(document).off('keydown', 'input, select')
    $(document).off('keydown')
    $(document).off('click', '.panel-title')
    $(document).off('click', '.panel-title')
  },*/

  destroyed () {
 $(document).off('keydown.dynamicEditor', 'input, select')
$(document).off('keydown.dynamicEditor')
  $(document).off('click', '.panel-title')
},

  watch: {
    '$route' (args) {
      this.showPreloader = true

      this.id          = args.params.id
      this.page        = args.params.page
      this.idStructure = args.params.idStructure
      this.parent      = args.params.parent

      if (!this.page && this.propDef) {
        this.page = this.propDef.code
      }
      if (!this.id && this.defaults && this.defaults.hasOwnProperty('ID')) {
        this.id = this.defaults.ID
      }

      this._initBase()
    }
  },

  methods: {

    /**
     * Zkontorluje zda-li jsou predana definicni data, pokud ne nacteje z API
     * @return {Promise<any>}
     * @private
     */
    _initDef () {
      if (this.propDef) {
        this.def = this.propDef
        return
      }

      let args    = {
            code:                   this.page,
            idtEntityStructureFrom: this.idStructure
          },
          success = (def) => {
            this.def = def
          }

      return DefinitionGetter
        .getDataDefinition(
          args, success, (error) => {this.handleApiError(error) })
    },

    /**
     * Zkontroluje, zdali jsou nactena data zaznamu, pokud ne nacte je z API
     * @return {Promise<any>}
     * @private
     */
    _initData () {
      if (((!this.id) || (this.id && this.defaults)) &&
        !this.homepageRedirect) {
        return new Promise(resolve => {
          this.innerDefaults = this.defaults
          resolve()
        })
      }

      // @TODO: hack user profile page load data for current user
      if (this.def.viewName === 'tUser' && !this.id) {
        this.id = this.$store.getters.user.id
      }

      return this
        .resource
        .setDef(this.def)
        .getById(this.id)
        .then((response) => {
          this.innerDefaults = response.data[0]
          this.dataInit      = true

          if (this.def.viewName === 'tUser') {
            this.innerDefaults['NEWPASSWORD']        = null
            this.innerDefaults['NEWPASSWORDCONFIRM'] = null
          }
        })
    },

    /**
     *
     * @private
     */
    _initBase () {
      if (this.subFormDefinitionFired) {
        this.subFormDefinitionFired = false
        return
      }

      Promise
        .all([this._initDef()])
        .then(() => {
          this.resource              = ResourceGetter.get(this.innerSourceType)
          this.resource.afterSaveRec = this.def.afterSaveRec
          this.buttonsDef            = this.def.editorButtons

          Promise
            .all([this._initData()])
            .then(() => {
              this.def.filterByData(this.innerDefaults)
              this.buttonsDef = this.def.editorButtons
              this.buttons    = this.def.editorMenuButtons

              this._parseFieldsData()
              this._setBreadcrumbs()
              this._prepareListIcons()
              this._prepareListImages()

              this.showDownload  = this._showDownloadButton()
              this.showPreloader = false
              this.dataChanged   = this._checkIfFormDataChange()

              if (window.location.hash) {
                for (let i = 0; i < this.innerSubForms.length; i++) {
                  let hash = window.location.hash
                  hash     = hash.replace('#', '')
                  if (this.innerSubForms[i].Code === hash) {
                    this._showSubForm(this.innerSubForms[i])
                    return
                  }
                }
              }
              else {
                this.renderBaseForm = true
              }

            })

        })
    },

    /**
     *
     * @private
     */
    _parseFieldsData () {
      this.innerSubForms            = []
      this.innerMasterSlave         = []
      this.gallery                  = null
      let interpretationIsSignature = false

      if (this.def.interpretation === FormElementTypes.signature) {
        interpretationIsSignature = true
      }

      for (let i = 0; i < this.def.editor.length; i++) {
        let field = this.def.editor[i]

        if (field.FieldType === FormElementTypes.enuEntForm) {
          if (field.Interpretation === 'MasterSlave') {
            this.innerMasterSlave.push(field)
            continue
          }

          if (field.Interpretation === 'Gallery') {
            this.gallery = field
            continue
          }

          // here are innerSubform - tabs I need for modal form
          this.innerSubForms.push(field)
        }

        if (field.FieldType === FormElementTypes.enuFormMenu) {
          this.innerFormMenu.push(field)
        }

        if (
          field.FieldType === FormElementTypes.document &&
          interpretationIsSignature) {
          field.FieldType = FormElementTypes.signature
        }
      }
    },

    /**
     * @private
     */
    _setBreadcrumbs () {
      let lastLabel = this.$translate.text('cfm_New')

      if (this.innerDefaults &&
        this.innerDefaults.hasOwnProperty('SEARCHTEXT')) {
        lastLabel = this.innerDefaults.SEARCHTEXT
      }

      this.breadcrumbItems = []
      this.breadcrumbItems.push({ name: 'Dashboard', label: 'Home' })

      if (this.parentParsed && this.parentParsed.length) {

        for (const parent of this.parentParsed) {
          if (parent.urlHash) {
            let editor = {
              name:   'PageDynamicEditor',
              hash:   parent.urlHash,
              params: {
                page:        parent.page,
                idStructure: parent.idEStructure,
                id:          parent.id,
                redir:       'grid',
                parent:      parent.parent
              },
              label:  parent.label
            }
            this.breadcrumbItems.push(editor)
          }
          else {
            let grid = {
              name:   'PageDynamicGrid',
              params: {
                page:        parent.page,
                idStructure: parent.idEStructure
              },
              label:  parent.label
            }
            this.breadcrumbItems.push(grid)
          }
        }

        let item = {
          name:   'PageDynamicEditor',
          label:  lastLabel,
          active: true
        }
        this.breadcrumbItems.push(item)

        return
      }

      let grid = {
        name:   'PageDynamicGrid',
        params: {
          page:        this.page,
          idStructure: this.idStructure,
          menuField:   this.def.response.data[0]
        },
        label:  this.def.dictionaryKeyCode
      }
      this.breadcrumbItems.push(grid)

      let item = {
        name:   'PageDynamicEditor',
        label:  lastLabel,
        active: true
      }
      this.breadcrumbItems.push(item)
    },

    /**
     *
     * @param data
     * @private
     */
    _formSubmit (data) {
      let success = (type, row) => {
            if (this.newrecordActionButtonFired) {
              type = 'insert'
            }

            SessionStorage.setArrayItem(
              SessionStorage.GRID_SUCCESS_ROW, { key: this.def.field, row: row })

            let rowData        = { type: type, data: row }
            this.innerDefaults = rowData.data

            if (this.setRowData) {
              this.$store.commit('setGridEditTag', true)
              this.$store.commit('setRowData', rowData)
            }

            this.setRowData = true

            if (this.submitSuccessCallbacks.length && !this.onlySave) {
              for (let i = 0; i < this.submitSuccessCallbacks.length; i++) {
                let callback = this.submitSuccessCallbacks[i]

                callback(data)
              }

              this.submitSuccessCallbacks = []
              return
            }

            this.rowData = rowData

            if (this.onlySave) {
              this.onlySave    = false
              this.dataChanged = false

              for (const ll of this.$refs.form.getValues().getValues()) {
                this
                  .$refs
                  .form
                  .getOriginalValues()
                  .setValue(ll.key, ll.value, ll.type)
              }
              if (!this.id) {
                let redir = 'grid'
                if (this.parentParsed) {
                  redir = 'self'
                }
                PDELinkGenerator.defaults = row
                PDELinkGenerator.redir    = redir
                PDELinkGenerator.parent   = this.parent
                this.$router.replace(
                  PDELinkGenerator.getParams(this.def))
              }

              this
                .resource
                .setDef(this.def)
                .getById(
                  this.innerDefaults.ID, { idtEntity: this.idStructure })
                .then((response) => {
                  Object.keys(response.data[0]).map(key => {
                    let stValue = response.data[0]['ST' + key]
                          ? response.data.values['ST' + key]
                          : response.data.values[key],
                        values  = {
                          value:   response.data[0][key],
                          stValue: stValue
                        }
                    this.$refs.form.setValue(key, values) //values
                    this.$refs.form.setValue(key, values, true) //originalValues

                    this.innerDefaults = response.data[0]
                  })

                  for (let i = 0; i < this.submitSuccessCallbacks.length; i++) {
                    let callback = this.submitSuccessCallbacks[i]

                    callback(data)
                  }
                  this.submitSuccessCallbacks = []
                })
                .catch((error) => {
                  this.handleApiError(error)
                })

              Swal.fire(
                {
                  icon:              'success',
                  title:             this.$translate.text('title_saved'),
                  text:              ' ',
                  timer:             1500,
                  showConfirmButton: false
                })

              return
            }

            if (this.homepageRedirect || this.dashboardRedirect) {
              this.$router.push({ name: 'Dashboard' })
              return
            }

            if (this.redir === 'grid') {
              this
                .$router
                .push({
                  name:   'PageDynamicGrid',
                  params: {
                    idStructure:     this.idStructure,
                    row:             rowData,
                    scrollFiredProp: true,
                    menuField:       this.def.response.data[0]
                  }
                })

              return
            }

            this.$router.go(-1)
          },

          process = (data) => {
            if (this.innerDefaults.hasOwnProperty('ID')) {
              data.ID = this.innerDefaults.ID
            }

            this.resource.idtEntity = this.idStructure

            if ((this.def.viewName === 'tUser' && data.NEWPASSWORD === null)
              || (this.def.viewName === 'tUser' && data.NEWPASSWORDCONFIRM ===
                null)
            ) {
              delete data.NEWPASSWORD
              delete data.NEWPASSWORDCONFIRM
            }

            // update dat pokud je nastavene id zaznamu
            if (data.ID) {
              this
                .resource
                .setDef(this.def)
                .update(data)
                .then(response => {
                  let data = response.data[0]

                  success('update', data)
                }).catch(error => {
                this.handleApiError(error)
                $('#tab-holder li a:first').addClass('active')
                $('#tab-holder li a:not(:first)').removeClass('active')
              })

              return
            }

            // insert dat pokud neni dostupne id zaznamu
            this
              .resource
              .setDef(this.def)
              .create({ data: data.data })
              .then(response => {
                data.data = response.data[0]

                success('insert', data.data)
              }).catch(error => {
              this.handleApiError(error)
              $('#tab-holder li a:first').addClass('active')
              $('#tab-holder li a:not(:first)').removeClass('active')
            })
          }

      // volani obchodniho pravidla VALREC
      if (this.def.valRec) {

        let value = Object.assign({}, this.innerDefaults)

        Object.keys(data.data).map(key => {
          value[key] = data.data[key]
        })

        let ruleParams = {
          ruleType: 'VALREC',
          ruleName: this.def.valRec,
          where:    this.subFormWhereCondition,
          value:    value
        }

        let promise = this
          .resource
          .setDef(this.def)
          .callBusinessRule(ruleParams)
          .then((response) => {

            Object.keys(response.data.values).map(key => {
              data.data[key] = response.data.values[key]
            })

            this._businessRulePromise(data, (overwrittenData) => {
              process(overwrittenData)

              if (response.data.messages) {
                Swal.fire(response.data.messages, '')
              }
            })

          }).catch((error) => {
            this.submitTriggered        = false
            this.submitSuccessCallbacks = []
            this.handleApiError(error, () => {
              this.showPreloader = false
            })
            $('#tab-holder li a:first').addClass('active')
            $('#tab-holder li a:not(:first)').removeClass('active')
          })

        this.businessRuleCallStack.push(promise)

        return
      }

      this._businessRulePromise(data, (overwrittenData) => {
        process(overwrittenData)
      })

    },

    /**
     *
     * @private
     */
    _submit (onlySave = false) {
      if (this.innerIsReadOnly === 'true') {
        return
      }

      this.onlySave        = onlySave
      this.submitTriggered = true

      this.$refs.form.submit()
    },

    /**
     *
     * @private
     */
    _delete () {
      if (this.innerIsReadOnly !== 'disable') {
        return
      }

      this.resource.idtEntity = this.idStructure

      let callback = () => {
        if (!this.def.delRec) {
          deleteItem()

          return
        }

        let ruleParams = {
          ruleType: 'DELREC',
          ruleName: this.def.delRec,
          where:    this.whereCondition,
          value:    this.innerDefaults
        }

        // @TODO: je potřeba zrfaktorovat volni vsech obchodnich pravidel!! ->
        // dat na jedno misto a predavat pouze typ pravidla -> vytvorit nejaky
        // 'volac' obchodnich pravidel
        this
          .resource
          .setDef(this.def)
          .callBusinessRule(ruleParams)
          .then((response) => {

            if (response.data.messages) {
              Swal.fire(response.data.messages, '')
            }

            deleteItem()
          }).catch((error) => {
          this.handleApiError(error)
        })
      }

      let deleteItem = () => {
        this
          .resource
          .setDef(this.def)
          .delete(this.innerDefaults.ID)
          .then(response => {
            if (this.redir === 'grid') {
              this.$store.commit('setGridEditTag', true)
              this.rowData = { type: 'delete', data: this.innerDefaults }
              this
                .$store
                .commit(
                  'setRowData', { type: 'delete', data: this.innerDefaults })
              this
                .$router
                .push({
                  name:   'PageDynamicGrid',
                  params: {
                    idStructure:     this.idStructure,
                    row:             this.innerDefaults,
                    scrollFiredProp: true,
                    menuField:       this.def.response.data[0]
                  }
                })

              return
            }

            this.$router.go(-1)
          }).catch(error => {
          this.handleApiError(error)
        })
      }

      Swal
        .fire({
          icon:              'warning',
          title:             this.$translate.text('cfm_Delete'),
          text:              this.$translate.text('cfm_delete_record'),
          showCancelButton:  true,
          cancelButtonText:  this.$translate.text('cfm_No'),
          confirmButtonText: this.$translate.text('cfm_Yes'),
          reverseButtons:    true
        })
        .then((result) => {
          if (result.value && result.value === true) {
            callback()
          }
        })
    },

    /**
     *
     * @private
     */
    _back () {
      if (this.homepageRedirect || this.dashboardRedirect) {
        this.$router.push({ name: 'Dashboard' })
        return
      }

      if (this.redir === 'grid' || !this.innerDefaults) {
        this
          .$router
          .push({
            name:   'PageDynamicGrid',
            params: {
              idStructure:     this.idStructure,
              row:             this.innerDefaults,
              scrollFiredProp: true,
              menuField:       this.def.response.data[0]
            }
          })
        return
      }

      if (this.parentParsed && this.parentParsed.length) {
        const parent = this.parentParsed[this.parentParsed.length - 1]

        if (!parent.page) {
          this.$router.go(-2)
          return
        }

        if (parent.urlHash) {
          this
            .$router
            .push({
              name:   'PageDynamicEditor',
              hash:   parent.urlHash,
              params: {
                page:        parent.page,
                idStructure: parent.idEStructure,
                id:          parent.id,
                redir:       'self',
                parent:      parent.parent
              },
              label:  parent.label
            })
        }
        else {
          this
            .$router
            .push({
              name:   'PageDynamicGrid',
              params: {
                page:        parent.page,
                idStructure: parent.idEStructure
              },
              label:  parent.label
            })
        }

        return
      }

      this.$router.go(-1)
    },

    /**
     *
     * @private
     */
    _renderBaseForm () {
      window.location.hash = ''

      this.subFormDefinition      = null
      this.subFormDefinitionFired = false
      this.changeUrlDisabled      = false
      this.showDownload           = false
    },

    /**
     *
     * @param subFormDefinition
     * @param event
     * @private
     */
    _showSubForm (subFormDefinition, event) {
      this.changeUrlDisabled = true
      this.form              = this.$refs.form

      let success = () => {
        if (event) {
          this.subFormDefinitionFired = true
          window.location.hash        = subFormDefinition.Code
        }

        let whereCondition = ''

        if (subFormDefinition.hasOwnProperty('WhereCondition')) {
          whereCondition = subFormDefinition.WhereCondition
        }

        whereCondition = whereCondition.replace('%ID%', this.innerDefaults.ID)

        this.renderBaseForm        = false
        this.rowData               = null
        this.subFormDefinition     = subFormDefinition
        this.subFormWhereCondition = whereCondition
        this.listIcons             = []
        this.listImages            = []
        this.buttonsDef            = []

        if (subFormDefinition.ViewName === 'tAttachment' &&
          this._showDownloadButton()) {
          this.showDownload = true
        }

        setTimeout(() => {
          if (window.location.hash) {
            $('#tab-holder li a').removeClass('active')
            $('#tab-holder li a[href="' + window.location.hash +
              '"]')
              .addClass('active')
          }
        }, 100)
      }

      this.formDataCheckFunction(success, this.id ? success : null)
    },

    /**
     *
     * @return {boolean}
     * @private
     */
    _checkIfFormDataChange () {
      return FormDataChangeHelper.changed(this.$refs.form, this.id)
    },

    /**
     * @TODO: potreba zrefaktorovat - na dvou mistech
     *        stejny kod v scheduler-event-form.vue::callBusinessRules
     * @param args
     * @private
     */
    _callBusinessRules (args) {
      let formCalrecCallback = (originalValue = null) => {
        // volani calrec nad celym formularem pokud je definovan
        if (this.def.calRec) {
          let value      = Object.assign({}, this.innerDefaults),
              formValues = this.$refs.form
                ? this.$refs.form._prepareSubmitData()
                : {}

          originalValue = originalValue === null && args &&
          value.hasOwnProperty(args.element.field)
            ? value[args.element.field]
            : originalValue

          if (originalValue === null) {
            originalValue = ''
          }

          if (args && args.value === originalValue) {
            return
          }

          if (args) {
            this.innerDefaults[args.element.field] = args.value
          }

          Object
            .keys(formValues)
            .map(key => {
              value[key] = formValues[key]
            })

          let where = this.subFormWhereCondition
          if (!where && this.def.whereCondition) {
            where = this.def.whereCondition.replace(
              '%IDLOGUSER%', this.innerDefaults.ID)
          }

          let options = {
                ruleType:   'CALREC',
                ruleName:   this.def.calRec,
                where:      where,
                columnName: args
                              ? args.element.field
                              : null,
                value:      value
              },
              promise = this
                .resource
                .setDef(this.def)
                .callBusinessRule(options)
                .then((response) => {
                  Object
                    .keys(response.data.values)
                    .map(key => {
                      let stValue = response.data.values['ST' + key]
                            ? response.data.values['ST' + key]
                            : response.data.values[key],
                          values  = {
                            value:   response.data.values[key],
                            stValue: stValue
                          }

                      if (this.$refs.form) {
                        this.$refs.form.setValue(key, values)
                      }
                      this.innerDefaults[key] = response.data.values[key]
                    })

                  this.def.filterByData(this.innerDefaults)
                  this.buttonsDef = this.def.editorButtons
                  if (this.$refs.form) {
                    this.$refs.form.changeEelement(this.def.dataFilters)
                  }

                  this._prepareListIcons()
                  this._prepareListImages()
                  this.dataChanged = this._checkIfFormDataChange()

                  if (response.data.messages) {
                    Swal.fire(response.data.messages, '')
                  }

                }).catch((error) => {
                  this.handleApiError(error)
                })

          this.businessRuleCallStack.push(promise)
        }
      }

      if (!args) {
        formCalrecCallback()

        return
      }

      // volani calrec nad elementem formulare pokud je definovan
      if (args.element.calrec) {
        let values = Object.assign({}, this.$refs.form._prepareSubmitData()),
            value  = args.value

        let originalValue = this.innerDefaults.hasOwnProperty(
          args.element.field)
          ? this.innerDefaults[args.element.field]
          : ''

        if (originalValue === null) {
          originalValue = ''
        }

        if (value === originalValue) {
          return
        }

        args.element.type = args.element.dataType // TODO: hack -> v
                                                  // FormValuesCollection je
                                                  // treba predelat propertu
                                                  // type na dataType !!

        if (args.element.dataType === 'nvarchar'
          && args.hasOwnProperty('stValue')
          && (args.element.field === args.element.fieldView)) {
          value = args.stValue
        }
        else {
          value = ValueTypeConverter.convert(args.element, value)
        }

        values[args.element.field]             = value
        this.innerDefaults[args.element.field] = value

        let options = {
              ruleType:   'CALREC',
              ruleName:   args.element.calrec,
              where:      this.subFormWhereCondition,
              columnName: args.element.field,
              value:      values
            },
            promise = this
              .resource
              .setDef(this.def)
              .callBusinessRule(options)
              .then((response) => {
                Object
                  .keys(response.data.values)
                  .map(key => {
                    let stValue = response.data.values['ST' + key]
                          ? response.data.values['ST' + key]
                          : response.data.values[key],
                        values  = {
                          value:   response.data.values[key],
                          stValue: stValue
                        }
                    if (this.$refs.form) {
                      this.$refs.form.setValue(key, values)
                    }
                    this.innerDefaults[key] = response.data.values[key]
                  })

                this.def.filterByData(this.innerDefaults)
                this.buttonsDef = this.def.editorButtons
                if (this.$refs.form) {
                  this.$refs.form.changeEelement(this.def.dataFilters)
                }

                this._prepareListIcons()
                this._prepareListImages()
                this.dataChanged = this._checkIfFormDataChange()

                if (response.data.messages) {
                  Swal.fire(response.data.messages, '')
                }

                formCalrecCallback(originalValue)
                this.innerOriginals[args.element.field] = args.value

              }).catch((error) => {
                // nastaveni puvodni hodnoty pokud dojde k nejakemu problemu
                // let originalValue = this.$refs.form
                //                         .getOriginalValues()
                //                         .getValue(args.element.field)
                // this.$refs.form
                //     .setValue(args.element.field, { value: originalValue })
                this.handleApiError(error, null, () => {
                  setTimeout(() => {
                    if (args.element.fieldType === FormElementTypes.inputbox) {
                      let value = this.innerOriginals.hasOwnProperty(args.element.field)
                        ? this.innerOriginals[args.element.field]
                        : ''
                      let element = this.$refs.form.setValue(args.element.field, {
                        value:   value,
                        stValue: value
                      })
                      element.focus()

                      setTimeout(() => {
                        element.select()
                      }, 150)
                    }
                  }, 500)
                })
              })

        this.businessRuleCallStack.push(promise)

        return
      }

      formCalrecCallback()
    },

    /**
     *
     * @param buttonSpecifications
     * @param event
     * @private
     */
    _buttonsClick (buttonSpecifications, event) {
      event.preventDefault()

      if (buttonSpecifications.hasOwnProperty('IsReadOnly')
        && buttonSpecifications.IsReadOnly === 'true'
      ) {
        event.stopPropagation()
        return
      }

      let value            = Object.assign({}, this.defaults),
          formValues       = this.$refs.form._prepareSubmitData(),

          callButtonAction = (responseData) => {

            if (responseData) {
              value = responseData.data
              responseData.ID ? value.ID = responseData.ID : null
            }
            else {

              Object.keys(this.innerDefaults).map(key => {
                value[key] = this.innerDefaults[key]
              })

              Object.keys(formValues).map(key => {
                value[key] = formValues[key]
              })
            }

            let args = {
              ruleType: 'Action',
              ruleName: buttonSpecifications.ViewName,
              where:    '',
              value:    value
            }

            this
              .resource
              .setDef(this.def)
              .callBusinessRule(args)
              .then((response) => {
                if (buttonSpecifications.Interpretation === 'Report') {
                  let html = response.data.values.HTML

                  this.$router.push({
                    name:   'PageDynamicEditorPrint',
                    params: {
                      content:   html,
                      resource:  this.resource,
                      buttonDef: buttonSpecifications,
                      data:      value
                    }
                  })
                  return
                }

                Object
                  .keys(response.data.values)
                  .map(key => {
                    let stValue = response.data[0]['ST' + key]
                          ? response.data.values['ST' + key]
                          : response.data.values[key],
                        values  = {
                          value:   response.data[0][key],
                          stValue: stValue
                        }

                    this.$refs.form.setValue(key, values) //values
                    this.$refs.form.setValue(key, values, true) //originalValues
                  })

                this.updateDataRequest(() => {
                  if (response.data.messages) {
                    Swal.fire(response.data.messages, '')
                  }
                })

              }).catch((error) => {
              this.updateDataRequest()
              this.handleApiError(error)
            })
          },

          process          = () => {
            /**
             * @TODO: duplicated in this file - _initFormDataChanged
             */
            if (this._checkIfFormDataChange() ||
              !this.innerDefaults.hasOwnProperty('ID')) {
              this.newrecordActionButtonFired = true
              this.submitSuccessCallbacks     = []
              this.setRowData                 = false
              this.$refs.form.submit()

              this.submitSuccessCallbacks.push((responseData) => {
                PDELinkGenerator.defaults = this.innerDefaults
                PDELinkGenerator.hash     = window.location.hash
                PDELinkGenerator.redir    = 'grid'

                this
                  .$router
                  .push(PDELinkGenerator.getParams(this.def))

                callButtonAction(responseData)
              })

              return
            }

            callButtonAction()
          }

      if (buttonSpecifications.Interpretation === 'Button!') {
        Bootbox.message    = this.$translate.text('cfm_confirm_message') +
          ' "' + this.$translate.text(buttonSpecifications.Label) + '" ?'
        Bootbox.title      = this.$translate.text('cfm_confirm') + ' ?'
        Bootbox.translator = this.$translate
        Bootbox.init(() => {
          process()
        })

      }
      else {
        process()
      }
    },

    /**
     *
     * @param buttonSpecifications
     * @return {string}
     * @private
     */
    _getButtonTarget (buttonSpecifications) {
      if (buttonSpecifications.ViewName === 'cstTask_Action_Navigate') {
        return 'https://www.google.com/maps/dir/?api=1&destination=' +
          this.innerDefaults['ADDRESSLATITUDE'] + '%2C' +
          this.innerDefaults['ADDRESSLONGITUDE']
      }
    },

    /**
     *
     * @return boolean
     * @private
     */
    _showDownloadButton () {
      for (let i = 0; i < this.def.editor.length; i++) {
        let field = this.def.editor[i]

        if (field.FieldType === FormElementTypes.document) {
          return true
        }
      }

      return false
    },

    /**
     *
     * @private
     */
    _download () {
      window.location.href = FileLoader
        .fileGUID(this.innerDefaults.FILEGUID)
        .downloadUrl(
          this.$store.getters.urlAppName, this.innerDefaults.FILENAME,
          this.innerDefaults.FILEYEAR, this.innerDefaults.FILEEXTENSION)
    },

    /**
     *
     * @param data
     * @param callback
     * @return {Promise<[any , any , any , any , any , any , any , any , any ,
     *   any] | never>}
     * @private
     */
    _businessRulePromise (data, callback) {
      return Promise
        .all(this.businessRuleCallStack)
        .then(() => {
          var form = this.$refs.form ? this.$refs.form : this.form
          if (this.businessRuleCallStack.length && form) {
            this.form             = undefined
            let updatedFormValues = form.getPreparedValues()
            Object
              .keys(updatedFormValues)
              .map(key => {
                data.data[key] = updatedFormValues[key]
              })
          }

          return callback(data)
        })
    },

    /**
     *
     * @private
     */
    _prepareListIcons () {
      this.listIcons = []

      if (!this.innerDefaults) {
        return
      }

      this.listIcons = this.def.getEditorIcons(this.innerDefaults)
    },

    /**
     *
     * @private
     */
    _prepareListImages () {
      this.listImages = []

      if (!this.innerDefaults) {
        return
      }

      this.def.editorImages.forEach((s) => {
        if (!this.innerDefaults.hasOwnProperty(s.ColumnName)) {
          return
        }

        this.listImages.push(
          {
            def:       s,
            value:     JSON.parse(this.innerDefaults[s.ColumnName]),
            extension: ''
          })
      })
    },

    /**
     *
     * @private
     */
    _dataLoadedListener () {
      this.showPreloader = false
    },

    /**
     *
     * @returns {{}}
     * @private
     */
    _getFormData () {
      return this.$refs.form.getValues().getValuesTransformed()
    },

    /**
     *
     * @private
     */
    _initFormDataCheckFunction () {
      this.formDataCheckFunction = (
        success, cancel = null, forceSuccess = false, successRedir = false) => {
        if (this.submitTriggered) {
          this.submitTriggered = false
          success()

          return
        }

        let formDataChange =
              this._checkIfFormDataChange() ||
              !this.innerDefaults ||
              !this.innerDefaults.hasOwnProperty('ID')

        if (formDataChange) {
          let module  = this,
              message = this.$translate.text('cfm_save_changes_info')

          if (!this.id) {
            message = this.$translate.text('cfm_continue_save_changes')
          }

          Swal
            .fire({
              icon:              'question',
              title:             this.$translate.text('cfm_save_changes'),
              text:              message,
              showCancelButton:  true,
              showCloseButton:   true,
              cancelButtonText:  this.$translate.text('cfm_No'),
              confirmButtonText: this.$translate.text('cfm_Yes'),
              reverseButtons:    true,
              onAfterClose:      () => {
                if (!window.location.hash) {
                  $('#tab-holder li a:first').addClass('active')
                  $('#tab-holder li a:not(:first)').removeClass('active')
                  $('#tab-holder li a:not(:first)').focus()
                }
              }
            })
            .then((result) => {
              if (result.value && result.value === true) {
                if (!module.id &&
                  (this.parentParsed && this.parentParsed.length > 1)) {

                  this._submit()
                  return
                }

                module.subFormDefinitionFired = false
                module.submitSuccessCallbacks = []
                module.setRowData             = false

                if ((module.id || forceSuccess)) {
                  module.$refs.form.submit()
                  module.submitSuccessCallbacks.push((data) => {
                    // redirect to now created new row
                    if (successRedir) {
                      PDELinkGenerator.defaults = data.data
                      PDELinkGenerator.redir    = module.backRedirect
                      module.$router.replace(
                        PDELinkGenerator.getParams(module.def))
                    }

                    if (typeof success === 'function') {
                      success(data)
                    }
                  })
                  return
                }

                if (!module.id) {
                  this._submit(true)
                  module.submitSuccessCallbacks.push(() => {

                    // PDELinkGenerator.defaults = module.innerDefaults
                    // PDELinkGenerator.hash     = window.location.hash
                    // PDELinkGenerator.redir    = 'grid'
                    //
                    // module
                    //   .$router
                    //   .push(PDELinkGenerator.getParams(module.def))
                    success()

                  })

                  return
                }

                module.submitSuccessCallbacks.push(() => {
                  success()
                })
              }
              if (result.dismiss &&
                (result.dismiss === 'cancel' || result.dismiss ===
                  'backdrop')) {
                if (cancel) {
                  cancel()
                }
                else {
                  $('#tab-holder li a:first').addClass('active')
                  $('#tab-holder li a:not(:first)').removeClass('active')
                  this.subFormDefinitionFired = false
                  window.location.hash        = ''
                }
              }
            })
        }
        else {
          success()
        }
      }
    },

    /**
     *
     * @private
     */
    _initUpdateDataRequest () {
      this.updateDataRequest = (successCallback) => {
        this
          .resource
          .setDef(this.def)
          .getById(this.innerDefaults.ID, { idtEntity: this.idStructure })
          .then((response) => {
            Object.keys(response.data[0]).map(key => {
              let stValue = response.data[0]['ST' + key]
                    ? response.data.values['ST' + key]
                    : response.data.values[key],
                  values  = {
                    value:   response.data[0][key],
                    stValue: stValue
                  }
              this.$refs.form.setValue(key, values) //values
              this.$refs.form.setValue(key, values, true) //originalValues
              this.innerDefaults = response.data[0]

              this.def.filterByData(this.innerDefaults)
              this.buttonsDef = this.def.editorButtons
              this.buttons    = this.def.editorMenuButtons

              this._prepareListIcons()
              this._prepareListImages()
            })

            if (successCallback) {
              successCallback()
            }
          })
          .catch((error) => {
            this.handleApiError(error)
          })
      }
    },

    _changeValue (args) {
      this.dataChanged = this._checkIfFormDataChange()
    },

    _elementsValueSetup () {
      this.dataChanged = this._checkIfFormDataChange()
    },

    /**
     *
     * @private
     */
    _initFormDataChanged () {
      this.formDataChanged = async (callback) => {
        if (this._checkIfFormDataChange() ||
          !this.innerDefaults.hasOwnProperty('ID')) {
          this.$refs.form.submit()

          this.submitSuccessCallbacks.push(async (responseData) => {
            await callback(responseData)
          })

          return
        }
        await callback()
      }
    },

    _openGallery () {
  // Použij ID z innerDefaults pokud this.id není dostupné

  console.log('_openGallery called')
  console.log('this.id:', this.id)
  console.log('this.innerDefaults:', this.innerDefaults)
  console.log('this.innerDefaults.ID:', this.innerDefaults ? this.innerDefaults.ID : 'innerDefaults is null')

  const recordId = this.id || (this.innerDefaults && this.innerDefaults.ID)

  if (!recordId) {
    console.error('Cannot open gallery - no ID available')
    Swal.fire({
      icon: 'warning',
      title: this.$translate.text('Error'),
      text: 'Cannot open gallery - record ID is missing'
    })
    return
  }

  let dataGetter    = new DataGetter()
  dataGetter.def    = new Definition({ data: [this.gallery] })
  dataGetter.id     = recordId  // Použij recordId místo this.id
  dataGetter.offset = 1
  dataGetter.limit  = 999999
  dataGetter.user   = this.$store.getters.user

  const success = (data) => {
    const items = []

    for (const image of data.data) {
      const src = FileLoader
        .fileGUID(image.FILEGUID)
        .downloadUrl(
          this.$store.getters.urlAppName,
          image.FILENAME,
          image.FILEYEAR,
          image.FILEEXTENSION
        ) + '?size=L'

      const inserted = DatetimeParser.parseDate(image.INSERTED)
        + ' '
        + DatetimeParser.parseTime(image.INSERTED)

      const title = inserted
        + (image.DESCRIPTION ? image.DESCRIPTION : '')
        + ' - '
        + image.ATTACHMENT_FILENAME

      items.push({ src: src, type: 'image', title: title })
    }

    if (!items.length) {
      items.push({
        src:  '<h3>' + this.$translate.text('title_no_images') + '</h3>',
        type: 'inline'
      })
    }

    $.magnificPopup.open({
      gallery: {
        enabled: true
      },
      items:   items
    })
  }

  dataGetter
    .get(success, (error) => {this.handleApiError(error)})
}
  }

}
